// src/supabaseClient.js
import { createClient } from '@supabase/supabase-js';

// Environment variables (loaded from Vercel or .env.local)
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Create and export the Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
